import React from 'react'
import loader from '../../assets/png/loader.png'

const Loader = () =>  <div className={"loader"}><img src={loader} alt=""/></div>

export default Loader